// src/components/Projects.js (Corrected)

import React from 'react';
// Assuming the import path is correct for your data
import projects from './Project'; 

const Projects = () => {
  return (
    
    <section id="projects" className="projects-section" style={{marginTop:'-50px'}}>
                <h2 className="section-title" style={{ color: '#2ECC71',marginTop:'-0px',fontSize:'2rem' }}> Recent Projects</h2>

      <div className="projects-content">
        
        <p className="section-subtitle">Showcasing innovative solutions delivered by Devulex.</p>
        
        <div className="projects-list-flat"> 
          {projects.map(project => (
            
            // This is where the error likely occurred due to comments or syntax issues
            <div className="project-item" key={project.id}> 
              
              {/* Image Column */}
              <div className="project-image-container-flat">
                <img 
                  src={project.imageUrl} 
                  alt={`Screenshot of the ${project.name} project`} 
                  className="project-image-flat"
                />
              </div>
              
              {/* Text Column */}
              <div className="project-info-flat">
               <h3>{project.name}</h3>
<p 
  className="project-description-flat" 
  style={{
    textAlign: 'justify' // <-- Justify the content
  }}
>
  {project.description}
</p>
                
                <div className="project-tech-flat">
                  {/* Ensure keys are used inside the map for tech tags */}
                  {project.tech.map(t => <span key={t} className="tech-tag-flat">{t}</span>)}
                </div>
                
                <div className="project-links-flat">
                  <a href={project.demo} target="_blank" rel="noopener noreferrer" className="link-demo-flat">View Project</a>
                </div>
              </div>

            </div> 
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;